import { ISarConfigSubRoot } from '@discngine/moosa-models';

export const selectSarColumns = (state: ISarConfigSubRoot) => state.sarConfig.columns;
export const selectSarStructure = (state: ISarConfigSubRoot) => state.sarConfig.structure;
export const selectConfigPanelMode = (state: ISarConfigSubRoot) =>
  state.sarConfig.isConfigPanelOpen;
export const selectSarImageSize = (state: ISarConfigSubRoot) => state.sarConfig.imageSize;
export const selectColorizingTextMode = (state: ISarConfigSubRoot) =>
  state.sarConfig.isColorizingTextMode;
